// Chart projections consume one accepted portfolio analysis. Missing values
// remain unavailable; measured zeroes and date order pass through unchanged.
export const chartFactorKey = (name) => `a__${encodeURIComponent(name).replace(/\./g, '%2E')}`;

export function latestFactorValueForSeries({ returns, factor, seriesKey, dateList }) {
    const series = returns?.by_factor?.[factor]?.[seriesKey] || {};
    for (let i = dateList.length - 1; i >= 0; i--) {
        if (dateList[i] in series) return series[dateList[i]];
    }
    const values = Object.values(series);
    return values.at(-1) ?? 0;
}

export function rankFactors({ byFactor, seriesKey, dateList }) {
    const score = (factor) => {
        const series = byFactor[factor]?.[seriesKey] || {};
        let value = null;
        for (let i = dateList.length - 1; i >= 0; i--) {
            if (dateList[i] in series) { value = series[dateList[i]]; break; }
        }
        if (value == null) value = Object.values(series).at(-1) ?? null;
        return Math.abs(Number(value || 0));
    };
    return Object.keys(byFactor || {}).map((factor) => [factor, score(factor)])
        .sort((a, b) => b[1] - a[1]).map(([factor]) => factor);
}

export function buildPerformanceChartData({
    returns, dateList, seriesKey, leftKey, rightKey,
    byFactor = false, selectedFactors = [], includeOtherFactors = false, includeAdjustment = false,
}) {
    return dateList.map((date) => {
        const row = {
            date,
            actual_total: returns?.total?.[seriesKey]?.[date] ?? null,
            actual_factor: returns?.[leftKey]?.[seriesKey]?.[date] ?? null,
            actual_idio: returns?.[rightKey]?.[seriesKey]?.[date] ?? null,
            actual_adjustment: includeAdjustment ? returns?.adjustment?.[seriesKey]?.[date] ?? null : null,
        };
        if (byFactor) {
            row.actual_factor_total = returns?.factor?.[seriesKey]?.[date] ?? null;
            for (const factor of selectedFactors) {
                row[chartFactorKey(factor)] = returns?.by_factor?.[factor]?.[seriesKey]?.[date] ?? null;
            }
            if (includeOtherFactors) {
                const values = selectedFactors.map((factor) => returns?.by_factor?.[factor]?.[seriesKey]?.[date]);
                row.actual_other_factors = Number.isFinite(row.actual_factor_total) && values.every(Number.isFinite)
                    ? row.actual_factor_total - values.reduce((sum, value) => sum + value, 0) : null;
            }
        }
        return row;
    });
}
